import LoadingConstants from './LoadingConsts'

export const disableLoading = (timeout = 0) => (dispatch) => {
  setTimeout(() => {dispatch({ type: LoadingConstants.DISABLE_LOADING })}, timeout);
}

export const setLoading = (message = 'Loading...') => (dispatch) => {
  dispatch({ type: LoadingConstants.SET_LOADING, payload: { message } })
}
